export enum DsiBenchmarkIndex {
    FPR = 'FPR', // 首屏可见
    FPE = 'FPE', // 首屏可编辑
    CCNR = 'CCNR', // 切页耗时
}

export const DSI_BENCHMARK_INDEXES = Object.keys(DsiBenchmarkIndex);
